export default {
  evaluation_list: {
    title: 'Supplier List',
    number_of_companies_answered: 'Submitted: {answered}/{total} Companies',
    number_of_companies_displayed: 'Show {start}-{end} of {total} companies',
    company_name: 'Company name',
    status: 'Status',
    questionnaire: 'Survey',
    plan: 'Plan',
    nothing: 'No results found',
  },
  evidence_options: {
    all_plan: 'All Plans',
    plans_with_vouchers: 'With evidence',
    no_voucher_plan: 'Without evidence',
  },
  table_headers: {
    company_name: 'Company name',
    status: 'Status',
    esg_rating: 'ESG Rating',
    esg_score: 'ESG Score',
    environment: 'Environment',
    social: 'Social',
    governance: 'Governance',
    plan: 'Plan',
    questionnaire: 'Survey',
    answer_date: 'Answer date',
    answer_expires_date: 'Deadline',
  },
  plan_list: {
    light: 'Light Plan',
    starter: 'Starter Plan',
    basic: 'Basic Plan',
    standard: 'Standard Plan',
    enterprize: 'Enterprize Plan',
  },
}
